import React from "react";
import { Alert, Button } from "@opendate-app/setlist";

const FailedSendAlert = ({ failedSend, onReschedule }) => (
  <Alert
    color="error"
    size="full-width"
    role="alert"
    title="This broadcast didn't send"
    description={`${failedSend.failure_reason} Fix it, then schedule it again.`}
    actions={<Button variant="secondary" size="sm" onClick={onReschedule}>Schedule again</Button>}
  />
);

export default FailedSendAlert;
